import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ExportOptions = () => {
  const [exportFormat, setExportFormat] = useState('pdf');
  const [isExporting, setIsExporting] = useState(false);

  const formatOptions = [
    { value: 'pdf', label: 'PDF Report' },
    { value: 'excel', label: 'Excel Spreadsheet' },
    { value: 'csv', label: 'CSV Data' },
    { value: 'pptx', label: 'PowerPoint Presentation' }
  ];

  const handleExport = () => {
    setIsExporting(true);
    setTimeout(() => {
      setIsExporting(false);
      alert(`Exporting workforce analytics as ${exportFormat?.toUpperCase()}...`);
    }, 2000);
  };

  const handleScheduleReport = () => {
    alert('Schedule report feature will open a modal for configuring automated exports');
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 h-full flex flex-col min-w-0">
      <div className="flex items-center gap-2 mb-4 min-w-0">
        <Icon name="Download" size={18} color="var(--color-primary)" className="flex-shrink-0 md:w-5 md:h-5" />
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground truncate">Export Options</h3>
      </div>

      <Select
        label="Export Format"
        options={formatOptions}
        value={exportFormat}
        onChange={setExportFormat}
        className="mb-4 w-full"
      />

      <div className="space-y-2 flex-1">
        <Button
          variant="default"
          size="default"
          onClick={handleExport}
          loading={isExporting}
          iconName="FileDown"
          iconPosition="left"
          fullWidth
          disabled={isExporting}
        >
          Export Now
        </Button>

        <Button
          variant="outline"
          size="default"
          onClick={handleScheduleReport}
          iconName="Calendar"
          iconPosition="left"
          fullWidth
          disabled={isExporting}
        >
          Schedule Report
        </Button>
      </div>

      <div className="mt-4 p-3 bg-muted rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={14} color="var(--color-primary)" className="mt-0.5 flex-shrink-0 md:w-4 md:h-4" />
          <div className="min-w-0 flex-1 overflow-hidden">
            <p className="caption text-[10px] md:text-xs text-foreground font-medium mb-1 break-words leading-relaxed">
              Executive Reports
            </p>
            <p className="caption text-[10px] md:text-xs text-muted-foreground break-words leading-relaxed">
              Scheduled reports are automatically generated and emailed to executives every Monday at 8:00 AM PGT
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportOptions;